import type { Places } from '~/types/places';

const PLACES_PROFILE: Places = {
  business: {
    bank: -15,
    government: -10,
    office: -15,
  },
  education: {
    childcare: -10,
    high_school: -5,
    library: 0,
    primary: -5,
    university: 0,
  },
  essentials: {
    electricity: 5,
    gas: 5,
    sewers: 5,
    waste: 5,
    water: 10,
  },
  food: {
    bakery: 5,
    coffee: 5,
    fast_food: 5,
    restaurant: 5,
  },
  health: {
    clinic: 5,
    dentist: -5,
    hospital: -5,
    pharmacy: 5,
  },
  nature: {
    beach: 15,
    forest: 15,
    lake: 15,
    mountain: 15,
    park: 15,
    river: 15,
  },
  religion: {
    church: 0,
    mosque: 0,
  },
  shops: {
    grocery: 8,
    mall: -10,
  },
  soil: {
    clay: 10,
    loam: 15,
    peat: 15,
    salt: -5,
    sand: 15,
    silt: 10,
  },
  sport: {
    gym: -5,
    pool: -10,
  },
  telecom: {
    cable_tv: -10,
    fiber_optic: -5,
    network_4g: 5,
    network_5g: 10,
    phone: 10,
  },
  transport: {
    airport: 5,
    bus: 7,
    ferry: 10,
    gas_station: 7,
    metro: 5,
    parking: 7,
    taxi: 10,
    train: 7,
    tram: 5,
  },
};

export default PLACES_PROFILE;
